<template>
    <div dir="ltr" class="tw-flex tw-items-center tw-gap-2 tw-h-[40px]">

        <div class="tw-max-w-[150px] tw-w-full tw-h-[70px]">
            <img :src="$frontend('assets/images/logo.png')" alt="logo" class="tw-w-full tw-h-full tw-object-contain" />
        </div>
    </div>
</template>